<template>
  <b-card no-body
          :img-src="recipe.bannerUrl"
          img-alt="Image"
          img-top
          tag="div"
          style="max-width: 20rem;"
          class="mb-2 recipe-card card-img-top"
  >
    <div class="bg-gray p-5 m-0 banner-fill" v-if="!recipe.bannerUrl">
      <span class="pl-4 ml-3" style="color: grey">
        <font-awesome-icon icon="book-reader" size="5x"></font-awesome-icon>
      </span>
    </div>
    <b-card-body>
      <b-card-title>
        <router-link
          class="text-blue card-text"
          :to="{ name: 'recipeView', params: { id: recipe.id }}"
          :title="getTitle"
          v-b-tooltip.hover.bottom>{{ getTitle | truncate(50, '...') }}
        </router-link>
      </b-card-title>
      <b-card-sub-title class="mb-2">
      </b-card-sub-title>
      <b-card-text class="text-justify card-text-description">
        {{ recipe.description | truncate(100, '...') }}
      </b-card-text>
    </b-card-body>
    <b-card-footer class="bg-white" v-if="isEditable || isDeletable || isShareable">
      <router-link class="text-dark mr-1" :to="{ name: 'recipeEdit', params: { id: recipe.id }}" v-if="isEditable"
                   title="Edit the recipe" v-b-tooltip.hover.bottom>
        <font-awesome-icon icon="edit"/>
        Edit
      </router-link>
      <b-link class="text-dark mr-1" @click.prevent="showMsgDelete(recipe.id, recipe.title)" v-if="isDeletable"
              title="Delete the recipe" v-b-tooltip.hover.bottom>
        <font-awesome-icon icon="trash-alt"/>
        Delete
      </b-link>
      <b-link to="#" @click.prevent="shareRecipe(recipe.id)" class="text-dark" v-if="isShareable"
              title="Share the recipe" v-b-tooltip.hover.bottom>
        <font-awesome-icon icon="share"/>
        Share
      </b-link>
    </b-card-footer>
  </b-card>
</template>

<script>
import {eventBus} from '../../main'

export default {
  name: 'recipeCard',
  props: {
    'recipe': Object
  },
  computed: {
    isShared () {
      // check if the recipe is shared
      if (this.recipe.rights === 'READ' || this.recipe.rights === 'WRITE') {
        return this.recipe.isShared
      }
    },
    isEditable () {
      // check if share action is allowed
      return this.recipe.rights === 'OWN' || this.recipe.rights === 'WRITE'
    },
    isDeletable () {
      // check if share action is allowed
      return this.recipe.rights === 'OWN'
    },
    isShareable () {
      // check if share action is allowed
      return this.recipe.rights === 'OWN'
    },
    getTitle () {
      let title = this.recipe.title
      if (title) {
        return title
      }
      return '<Untitled>'
    }
  },
  methods: {
    showMsgDelete (recId, recTitle) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this recipe.', {
        title: 'Are you sure you want to delete ' + recTitle + '?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteRecipe(recId)
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    deleteRecipe (recipeId) {
      this.$store.dispatch('deleteRecipeEntity', recipeId).then(
        data => {
          window.location.reload()
        })
    },
    shareRecipe (recipeId) {
      let b = [recipeId, this.recipe.title]
      console.log(b)
      eventBus.$emit('shareRecipe', b)
    }
  }
}
</script>

<style scoped>
  .recipe-card {
    height: 460px !important;
  }

  .banner-fill {
    height: 180px !important;
    max-height: 180px !important;
    box-shadow: none !important;
  }

  .recipe-card:hover {
    box-shadow: 2px 2px 2px 2px #bbbbbb;
  }

  .card-img-top {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }

  .card-text {
    font-size: 20px !important;
  }
  .card-text-description {
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeCard.vue